import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { SectionTitle } from '../../../../../components/text';
import { TranslationsKeys } from '../../../../../locales/translations';
import CourseActivityTypeSection from '../sections/CourseActivityTypeSection';
import CourseAttendanceSection from '../sections/CourseAttendanceSection';
import CourseCompatibilitiesSection from '../sections/CourseCompatibilitiesSection';
import CourseDetailsSection from '../sections/CourseDetailsSection';
import CourseGroupingsSection from '../sections/CourseGroupingsSection';
import CourseOptionalDetailsSection from '../sections/CourseOptionalDetailsSection';
import CoursePrerequisitesSection from '../sections/CoursePrerequisitesSection';

type CourseAdministrativeTabProps = {
  readOnly?: boolean;
};

/**
 * HU 15624 — Pestaña Administrativo dividida en dos secciones (FRD §1.3.a):
 *
 *   Sección 1 — Detalles principales (campos obligatorios):
 *     - Datos básicos: sigla, código, nombre, escuela, modalidad, nivel,
 *       créditos.
 *     - Subsección "Configuración adicional".
 *     - Subsección "Composición de la Actividad/Asignatura" (checkboxes).
 *
 *   Sección 2 — Detalles opcionales:
 *     - Horas Totales / Presenciales / Semanales de la asignatura completa.
 *     - Tabla "Horas y Asistencia Requerida por Componente" (4 columnas).
 *
 * Las secciones de Prerrequisitos, Agrupaciones y Equivalencias se renderizan
 * a continuación SIN cambios funcionales; sólo se les agrega un texto
 * descriptivo (FRD §1.4) dentro de cada componente.
 */
const CourseAdministrativeTab = ({
  readOnly = false,
}: CourseAdministrativeTabProps) => {
  const { t } = useTranslation(TranslationsKeys.ACADEMIC_OFFER_COURSES_UPDATE);

  return (
    <>
      <section className="pt-3">
        <SectionTitle text={t(`mainDetailsSection`)} />
        <CourseDetailsSection readOnly={readOnly} />
        <CourseActivityTypeSection readOnly={readOnly} />
      </section>

      <hr className="my-5" />

      <section>
        <SectionTitle text={t(`optionalDetailsSection`)} />
        <CourseOptionalDetailsSection readOnly={readOnly} />
        <CourseAttendanceSection readOnly={readOnly} />
      </section>

      <section>
        <Row className="pt-4">
          <Col xs={12}>
            <CourseGroupingsSection readOnly={readOnly} />
          </Col>
          <Col xs={12}>
            <CoursePrerequisitesSection readOnly={readOnly} />
          </Col>
          <Col xs={12}>
            <CourseCompatibilitiesSection readOnly={readOnly} />
          </Col>
        </Row>
      </section>
    </>
  );
};

export default CourseAdministrativeTab;
